import { useGAPageViews } from '../hooks/useGAPageViews';

export default function GAListener() {
  useGAPageViews();
  return null;
}
